<!--@format-->
<template>
    <div class="decline-to-sign-popup">
        <section class="description">
            <p>
                After clicking "Decline" you will no longer have access to the document or receive
                any further notifications.
            </p>
        </section>
        <section class="reasons-for-declining">
            <label>Reasons for declining</label>
            <app-input-radio v-model="declineReason" :options="ReasonForDeclining" centered />
        </section>
        <section class="add-message">
            <label>Add a message</label>
            <app-text-area v-model="message" :rows="2" />
        </section>
        <div class="app-popup-actions inner-actions">
            <app-button class="tertiary-btn" @click="closePopup"> Cancel </app-button>
            <app-button class="removeNotIcon" :disabled="noSelection" @click="declineSigning">
                Decline
            </app-button>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const AppInputRadio = () => import('@/components/common/app-input-radio');
const AppTextArea = () => import('@/components/common/app-textarea');

import EventBus from '@/scripts/event-bus';
import { isNil } from 'lodash';

export default {
    name: 'decline-to-sign-popup',

    components: {
        'app-button': AppButton,
        'app-input-radio': AppInputRadio,
        'app-text-area': AppTextArea,
    },

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            declineReason: null,
            message: null,
            ReasonForDeclining: [
                {
                    name: 'Not interested',
                },

                {
                    name: 'Pricing',
                },

                {
                    name: 'Timing is not right',
                },

                {
                    name: "It's spam",
                },
            ],
        };
    },

    computed: {
        noSelection() {
            return isNil(this.declineReason);
        },
    },

    methods: {
        declineSigning() {
            const notificationContent = `${this.declineReason.name}. ${this.message || ''}`;
            EventBus.$emit('document:perform-decline', notificationContent);
            this.closePopup();
        },

        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.decline-to-sign-popup {
    text-align: left;
}

.decline-to-sign-popup label,
.decline-to-sign-popup .app-input-radio label {
    color: #382153;
    font-size: 16px;
    line-height: 24px;
    font-family: 'Roboto';
}

.decline-to-sign-popup .reasons-for-declining .app-input-radio {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.decline-to-sign-popup .reasons-for-declining .app-input-radio .option {
    margin-bottom: 8px;
}

.decline-to-sign-popup .reasons-for-declining .app-input-radio .circle {
    z-index: 1;
}

.decline-to-sign-popup .add-message .app-textarea textarea {
    resize: none;
    min-height: 88px;
    border: 1px solid #cac6cb;
    border-radius: 15px;
    margin-bottom: 33px;
}

.decline-to-sign-popup .app-popup-actions.inner-actions {
    border-top: 2px solid #e9e9ef;
}

.decline-to-sign-popup .add-message .app-textarea textarea::-webkit-scrollbar {
    width: 9px;
    height: 9px;
}

.decline-to-sign-popup .add-message .app-textarea textarea::-webkit-scrollbar-track {
    border-radius: 32px;
}

.decline-to-sign-popup .add-message .app-textarea textarea::-webkit-scrollbar-thumb {
    border-radius: 32px;
    background: rgb(193, 193, 197);
}
</style>
